import type { TTerm } from '@/types'
import { LOCALES } from '@/common'
import { SOURCES, TAGS, TYPES } from '@/data/raw'

export default {
  id: `blockchain`,

  name: {
    [LOCALES.EN_US]: `Blockchain`,
  },

  label: {
    [LOCALES.EN_US]: ``,
  },

  definition: {
    [LOCALES.EN_US]: ``,
  },

  type: [TYPES.concept, TYPES.protocol],

  tags: [],
} as const satisfies TTerm
